import { AuthConfig } from 'angular-oauth2-oidc';
import { environment } from '../environments/environment';

export const authConfig: AuthConfig = {
  issuer: environment.SSO.stsServer,
  loginUrl: environment.SSO.stsServer + '/connect/authorize',
  logoutUrl: environment.SSO.stsServer + '/Account/logout',
  redirectUri: `${environment.URL_Front}signin-oidc`,
  clientId: 'customerjourneyadmin',
  scope: 'accesEspaceClient openid profile',
  oidc : true,
  userinfoEndpoint : environment.SSO.stsServer + '/connect/userinfo',
  tokenEndpoint : environment.SSO.stsServer + '/connect/token',
  requestAccessToken: true,
  //responseType: "id_token token",
  showDebugInformation: true,
  postLogoutRedirectUri: `${environment.URL_Front}autologin`,
  useSilentRefresh: true,
  silentRefreshRedirectUri: window.location.origin + '/assets/silent-refresh.html',
  useIdTokenHintForSilentRefresh: true
};
